<script setup lang="ts">
  import { appRouteDefinitions } from '@gat-ship/lib/router'
  import { useRoute } from '@gat-ship/lib/router'
  import { Spinner } from '@gat-ship/vue-components'
  import { StartupState, _useAppState } from '@gat-ship/lib/app-state'
  import { useAuth0 } from '@gat-ship/lib/auth'
  import { shallowRef, type Component, watch, h } from 'vue'
  import AppLogo from './app-logo.vue'
  import { AppError, ErrorCode } from '@gat-ship/lib/error-handling'
  import { BtnThemeToggle } from '@gat-ship/shared'
  import BtnSignOut from './actions/btn-sign-out.vue'
  const route = useRoute()

  const { logout } = useAuth0()
  const appState = _useAppState()

  const component = shallowRef<Component | undefined>(undefined)

  async function loadComponent(
    error: AppError
  ): Promise<Component | undefined> {
    if (error.code === ErrorCode.DB_ACCESS_MISSING) {
      return (await import('./app-error-no-databases.vue'))['default']
    }
    return h('div', { class: 'text-red-500 mx-auto' }, [
      h('p', error.message),
      h('p', error.code)
    ])
  }

  watch(
    appState.startupState.startupStateError,
    async (error) => {
      if (error) {
        component.value = await loadComponent(error)
      }
    },
    {
      deep: true
    }
  )
</script>
<template>
  <div class="flex p-2">
    <app-logo
      class="m-2 max-w-[100px]"
      v-if="appState.startupState.startupStateError.value"
    />
    <btn-theme-toggle class="ml-auto" variant="ghost" show-tooltip />
    <btn-sign-out
      variant="ghost"
      size="icon"
      show-tooltip
      v-if="appState.startupState.startupStateError.value"
    />
  </div>
  <component v-if="component" :is="component" />
  <div
    v-else-if="
      appState.startupState.startupState.value.includes(
        StartupState.Initializing
      )
    "
    class="container mx-auto"
  >
    <div class="flex h-dvh flex-col items-center justify-center pb-32">
      <app-logo style="max-width: 350px" />
      <spinner
        v-if="!appState.startupState.startupStateError.value"
        class="mt-16 h-16 w-16 opacity-10"
      ></spinner>
    </div>
  </div>
  <div v-show="false">
    <!-- Add router-view here because of callback-url and callback component's internal functions. -->
    <router-view
      v-if="route.name === appRouteDefinitions.auth.oAuth2Callback"
    />
  </div>
</template>
